import React from 'react';
import AdminRowIcon from '../../components/admin/AdminRowIcon';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonContent,
  IonSearchbar,
  IonList,
  IonItem,
  IonLabel,
  IonBadge,
  IonButton,
  IonSpinner,
  IonText,
  IonAlert,
} from '@ionic/react';
import { useAdminUsers } from '../../../application/use-cases/admin/useAdminUsers';
import AdminListFooter from '../../components/admin/AdminListFooter';
import './Admin.css';

const AdminUsers: React.FC = () => {
  const {
    query,
    setQuery,
    loading,
    error,
    busyId,
    confirm,
    setConfirm,
    toast,
    toggleAdmin,
    toggleDisabled,
    sendReset,
    filtered,
    total,
    loadingMore,
    loadMore,
  } = useAdminUsers();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/admin" />
          </IonButtons>
          <IonTitle>Usuarios ({total.toLocaleString('es-AR')})</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSearchbar
            value={query}
            placeholder="Buscar por nombre o email"
            onIonInput={(e) => setQuery(e.detail.value ?? '')}
          />
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        {loading && (
          <div className="ion-text-center ion-padding">
            <IonSpinner color="primary" />
          </div>
        )}
        {error && (
          <IonText color="danger">
            <p className="ion-padding">{error}</p>
          </IonText>
        )}
        {toast && (
          <IonText color="success">
            <p className="ion-padding">{toast}</p>
          </IonText>
        )}

        <IonList className="admin-list">
          {filtered.map((u) => (
            <IonItem key={u.id} lines="full">
              <AdminRowIcon initial={(u.name || u.email).trim().charAt(0).toUpperCase()} tone={u.isDisabled ? 'grey' : u.isAdmin ? 'violet' : 'green'} />
              <IonLabel>
                <h2>{u.name}</h2>
                <p>{u.email}</p>
                <p className="admin-list-row-meta">
                  {u.deviceCount} estaci{u.deviceCount === 1 ? 'ón' : 'ones'} · desde{' '}
                  {new Date(u.createdAt).toLocaleDateString('es-AR')}
                </p>
                <div className="admin-row-actions">
                  <IonButton size="small" fill="clear" disabled={busyId === u.id} onClick={() => toggleAdmin(u)}>
                    {u.isAdmin ? 'Sacar admin' : 'Dar admin'}
                  </IonButton>
                  <IonButton
                    size="small"
                    fill="clear"
                    color={u.isDisabled ? 'success' : 'danger'}
                    disabled={busyId === u.id}
                    onClick={() => toggleDisabled(u)}
                  >
                    {u.isDisabled ? 'Habilitar' : 'Deshabilitar'}
                  </IonButton>
                  <IonButton size="small" fill="clear" disabled={busyId === u.id} onClick={() => sendReset(u)}>
                    Reset de contraseña
                  </IonButton>
                </div>
              </IonLabel>
              {u.isAdmin && <IonBadge color="tertiary">Admin</IonBadge>}
              {u.isDisabled && <IonBadge color="danger">Deshabilitado</IonBadge>}
            </IonItem>
          ))}
        </IonList>
        {!loading && <AdminListFooter shown={filtered.length} total={total} loadingMore={loadingMore} onMore={loadMore} />}

        <IonAlert
          isOpen={!!confirm}
          onDidDismiss={() => setConfirm(null)}
          header={confirm?.header}
          message={confirm?.message}
          buttons={[
            { text: 'Cancelar', role: 'cancel' },
            { text: 'Confirmar', handler: () => confirm?.onConfirm() },
          ]}
        />
      </IonContent>
    </IonPage>
  );
};

export default AdminUsers;
